// extracted by mini-css-extract-plugin
module.exports = {"content":"_2T6C0Wi","heading":"X3peGBm","link":"_2bJ1fgU"};
    if(module.hot) {
      // 1545369437627
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  